import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "bg-white border border-primary-200 rounded-xl shadow-soft p-4 overflow-hidden" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "text-lg font-heading font-semibold text-primary-800 mb-3" }, " Quick Links ", -1)
const _hoisted_3 = { class: "grid grid-cols-2 gap-2" }
const _hoisted_4 = { class: "text-sm font-medium text-primary-700 group-hover:text-primary-900 truncate" }

import { h } from "vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const links = [
  {
    label: "Pay Dues",
    to: "/payments",
    iconBg: "bg-green-100 group-hover:bg-green-200",
    iconColor: "w-4 h-4 text-green-600",
    icon: h(
      "svg",
      {
        class: "w-4 h-4",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24",
      },
      [
        h("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z",
        }),
      ]
    ),
  },
  {
    label: "Photo Gallery",
    to: "/gallery",
    iconBg: "bg-pink-100 group-hover:bg-pink-200",
    iconColor: "w-4 h-4 text-pink-600",
    icon: h(
      "svg",
      {
        class: "w-4 h-4",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24",
      },
      [
        h("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z",
        }),
      ]
    ),
  },
  {
    label: "Neighbor Posts",
    to: "/posts",
    iconBg: "bg-blue-100 group-hover:bg-blue-200",
    iconColor: "w-4 h-4 text-blue-600",
    icon: h(
      "svg",
      {
        class: "w-4 h-4",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24",
      },
      [
        h("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z",
        }),
      ]
    ),
  },
  {
    label: "My Profile",
    to: "/profile",
    iconBg: "bg-purple-100 group-hover:bg-purple-200",
    iconColor: "w-4 h-4 text-purple-600",
    icon: h(
      "svg",
      {
        class: "w-4 h-4",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24",
      },
      [
        h("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z",
        }),
      ]
    ),
  },
];

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(links, (link) => {
        return _createVNode(_component_router_link, {
          key: link.to,
          to: link.to,
          class: "flex items-center gap-2 p-3 rounded-lg hover:bg-primary-50 transition-colors group min-w-0"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(["w-8 h-8 rounded-lg flex items-center justify-center transition-colors flex-shrink-0", link.iconBg])
            }, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(link.icon), {
                class: _normalizeClass(link.iconColor)
              }, null, 8, ["class"]))
            ], 2),
            _createElementVNode("span", _hoisted_4, _toDisplayString(link.label), 1)
          ]),
          _: 2
        }, 1032, ["to"])
      }), 64))
    ])
  ]))
}
}

})